import { ReactNode } from 'react';

type ShowProps = {
  when: boolean;
  children: ReactNode;
  fallback?: ReactNode;
};

export function Show({ when, children, fallback = null }: ShowProps) {
  return <>{when ? children : fallback}</>;
}
